// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1___018e1631e40ffec90e3{/*!*/}.common-cls2___47530eb16eac081ed52{align-items:center;background:#fff;border:0;border-radius:4px;box-shadow:0px 2px 4px rgba(0,0,0,.08);color:#0954d3;display:flex;font-weight:500;font-size:16px;height:32px;padding:0 30px;white-space:nowrap}.common-cls2___47530eb16eac081ed52:hover{text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1___018e1631e40ffec90e3",
	"cls2": "common-cls2___47530eb16eac081ed52 common-cls1___018e1631e40ffec90e3"
};
export default ___CSS_LOADER_EXPORT___;
